import AddCircleIcon from "@mui/icons-material/AddCircle"
import { Box, Button, Container, Grid, Typography, useTheme } from "@mui/material"
import { useApi } from "auth/useApi3"
import ClpTable from "components/ClpTable"
import { MultiSelectFilter } from "components/ClpTable/ClpTableFilterTypes"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import moment from "moment"
import { Link, useHistory } from "react-router-dom"

import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"
import TableLink from "components/ClpTable/components/actions/TableLink/TableLink"
import { StyledBoldTypography } from "components/ClpTable/components/typography/typography.styled"
import { StyledPageHeader } from "components/Headers/PageHeader.styled"
import ChipInfoIcon from "components/Status/ChipInfo/ChipInfoIcon"
import { workOrderChip } from "components/Status/helpers/statusProps"
import { workorderStatusLabel } from "helpers/WorkOrder/WorkOrderStatusLabel"
import { useContext, useEffect } from "react"
import Moment from "react-moment"
import { StyledTableContainer } from "shared/styled/Global"
import { useTranslation } from "react-i18next"
import { includesPrimitiveFilter } from "components/ClpTable/components/helpers/includesFilterFn"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import { StyledFontAwesomeIconForButton } from "shared/styled/General"

const WorkOrders = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const loadingContext = useContext(GlobalLoaderContext)
  const theme = useTheme()
  const [workOrdersResult, workOrdersFuncs] = useApi()

  useEffect(() => {
    workOrdersFuncs.get(apiEndpoints.issuereportsadmin.getworkorders)
    return () => {
      workOrdersFuncs.leave()
    }
  }, [workOrdersFuncs])

  useEffect(() => {
    loadingContext.setLoading(() => workOrdersResult.status === 1)
  })

  const columns = [
    {
      accessorKey: "id",
      header: t("global.table.id", "ID"),
      cell: ({ cell }) => {
        return <StyledBoldTypography>{cell.row.original.id}</StyledBoldTypography>
      }
    },
    {
      accessorKey: "regNumber",
      header: t("global.table.regnr", "Reg no"),
      cell: ({ cell }) => {
        return (
          <TableLink
            label={cell.row.original.regNumber}
            to={allRoutes.VehicleregistryVehiclesDetails(cell.row.original.vehicleId)}
          />
        )
      }
    },
    {
      accessorKey: "internNumber",
      header: t("global.table.internal_number", "Internal no")
    },
    {
      accessorKey: "message",
      header: t("global.message", "Message")
    },
    {
      accessorKey: "emailRecipient",
      header: t("global.send_to", "Send to")
    },

    {
      accessorKey: "plannedDate",
      header: t("global.planned_action", "Planned action"),
      cell: ({ cell }) => {
        return cell.row.original.plannedDate
          ? moment.utc(cell.row.original.plannedDate).local().format("YYYY-MM-DD HH:mm")
          : "-"
      }
    },
    {
      accessorKey: "resolvedDate",
      header: t("global.fixed", "Fixed"),
      cell: ({ cell }) => {
        return cell.row.original.resolvedDate ? (
          <Moment format="YYYY-MM-DD" globallocale="sv">
            {cell.row.original.resolvedDate}
          </Moment>
        ) : (
          "-"
        )
      }
    },
    {
      accessorFn: (row) => row.status,
      header: t("global.status", "Status"),
      filterFn: (row, columnId, filterValue) => includesPrimitiveFilter({ row, columnId, filterValue }),
      meta: {
        mainFilter: true,
        filter: MultiSelectFilter,
        filterOptions: [
          {
            name: t("global.new", "New"),
            value: 1
          },
          {
            name: t("global.sent", "Sent"),
            value: 2
          },
          {
            name: t("global.ongoing", "Ongoing"),
            value: 3
          },
          {
            name: t("global.completed", "Completed"),
            value: 5
          },
          {
            name: t("global.cancelled", "Cancelled"),
            value: 6
          }
        ]
      },
      cell: ({ cell }) => {
        return cell.row.original.status && <ChipInfoIcon type={workOrderChip(cell.row.original.status)} />
      }
    }
  ]

  return (
    <div>
      <Container>
        <Box>
          <StyledPageHeader>
            <Grid item>
              <Typography variant="h2">{t("global.workorders", "Work orders")}</Typography>
              <Typography>{t("issuereports.administer_workorders", "Administer work orders")}</Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                component={Link}
                to={allRoutes.IssuereportsWorkordersAdd()}
                color="primary">
                {t("global.create_work_order", "Create work order")}
              </Button>
            </Grid>
          </StyledPageHeader>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          onRowClick={(row) => history.push(allRoutes.IssuereportsWorkordersDetails(row.original.id))}
          columns={columns}
          rows={workOrdersResult.status === 2 && workOrdersResult.data}
          loadingState={workOrdersResult.status}
          tableId={ClpTableEnum.IssuReportsWorkOrders}
        />
      </StyledTableContainer>
    </div>
  )
}

export default WorkOrders
